module.exports = __webpack_public_path__ + "img/xiangshui(13).2bdd8b23.png";